import { render, staticRenderFns } from "./diapositiva-10.vue?vue&type=template&id=53420e48&scoped=true&"
import script from "./diapositiva-10.vue?vue&type=script&lang=js&"
export * from "./diapositiva-10.vue?vue&type=script&lang=js&"
import style0 from "./diapositiva-10.vue?vue&type=style&index=0&id=53420e48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53420e48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/Backup_Juan/ecopetrol/Cursos 2019/hidrocarburos/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib'
installComponents(component, {VLayout})
